/**
 * Crowd Control State Machine (Mez, Stun, Root, Snare)
 * Implements DAoC rule: Mez breaks immediately upon receiving damage!
 */

import { EntityState } from '../../core/Types';
import { EventBus } from '../../core/EventBus';

export class CCStateMachine {
  public applyCC(
    target: EntityState,
    type: 'stun' | 'mez' | 'root' | 'snare',
    duration: number,
    sourceName: string,
    snarePct?: number
  ): void {
    if (target.isDead) return;

    target.cc = {
      type,
      duration,
      remaining: duration,
      snarePct,
    };

    // If casting, Stun or Mez interrupts it
    if (target.cast && (type === 'stun' || type === 'mez')) {
      const spellName = target.cast.skillName;
      target.cast = null;
      EventBus.emit('CAST_INTERRUPTED', {
        entityId: target.id,
        entityName: target.name,
        spellName,
        reason: 'damage',
      });
    }

    EventBus.emit('CC_APPLIED', {
      targetId: target.id,
      ccType: type,
      duration,
      sourceName,
    });
  }

  public update(entity: EntityState, dt: number): void {
    if (!entity.cc) return;

    entity.cc.remaining -= dt;
    if (entity.cc.remaining <= 0) {
      entity.cc = null;
    }
  }

  /**
   * Called whenever an entity takes damage.
   * If under Mez, the sleep effect breaks immediately!
   */
  public onTakeDamage(target: EntityState, damage: number, breakerName: string): void {
    if (damage <= 0 || !target.cc) return;

    if (target.cc.type === 'mez') {
      target.cc = null;
      EventBus.emit('MEZ_BROKEN', {
        targetId: target.id,
        breakerName,
      });
    }
  }

  public canAct(entity: EntityState): boolean {
    if (entity.isDead) return false;
    if (entity.cc && (entity.cc.type === 'stun' || entity.cc.type === 'mez')) {
      return false;
    }
    return true;
  }

  public canMove(entity: EntityState): boolean {
    if (!this.canAct(entity)) return false;
    if (entity.cc && entity.cc.type === 'root') return false;
    return true;
  }
}

export const CrowdControl = new CCStateMachine();
